import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/Users/cattoire/data/git/instana-humio-hybrid-systemZ/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ArticleCard = makeShortcode("ArticleCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Introduction`}</h2>
    <p>{`This lab will introduce Instana and then illustrate how it can be used for an application which makes use of some mainframe components.`}</p>
    <p>{`We have already instrumented the application for you and through the various lab exercises you will explore the capabillities of the combination of Instana.`}</p>
    <p>{`1) In the first portion of the lab, students will get a good idea of the standard capabillities of Instana. If you are already familiar
with the Instana Observabillity solution you could skip to the second part which looks into the specific SystemZ capabillities.`}</p>
    <p>{`2) The second part of the lab looks at how these same techniques can be applied on SystemZ components.`}</p>
    <p>{`After completing the Login section, use the other links to go directly to one of the lab exercises.`}</p>
    <p>{`When you first login to the Soleil virtual machines, a chrome browser will be open with multiple tabs.  The first tab will be this lab guide.  We recommend that you use
the lab guide within the virtual machine so that you can easily copy and past text into the terminal windows.`}</p>
    <h2>{`Logging into the Environment`}</h2>
    <p>{`  Before beginning the exercises, take the following steps to login to the soleil environment and access the lab environment.`}</p>
    <p>{`  After opening your browser and logging into the lab, you’ll see an image of a computer.  It is named Student1. This
virtual machine is the Client machine from which you will access the different environments.`}</p>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "78.47222222222221%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAQCAYAAAAWGF8bAAAACXBIWXMAABYlAAAWJQFJUiTwAAABwElEQVQ4y62UXWsTQRSG928J4t/xRqhSpSjeFEHECysiGAlNheLXpRe9q+KNFqslJTGhbagx2XSjycbuzmRndnaz+0g2Sb0QZVcceJgzH5x5D5x3rKatqXbGpPyfYVX7Bxx3HGynj+04dHo97BOH/vcB3d4J7W4XqRRS6fn8d6yd1i77tTq1RpOjL21a7a80D49o2z2OO91s/UPI3Fi+0PiBwg80QoWIqRIdZnuL+FSOc2M5g2+zhRB481cWhyNfZBRSOBAxOtR4QYgrNSLQ+EJkhCYiNAZjIqI4zoXlBprYhFnJQ6EY6xApBVJKkmTCZDIhSRJIU9IcWPv9A9yRQimF0gZ3HOEG0W/tkOZNeOj4tAdDBKBI8Y1hHEZzRb8S5e7DOh94+/kjlRcveb71hnd2jTqfiJKokLIzhXu85+K1JS6cO89aaYtXjSq7vCZMzFnCQk5psMfdJ7e59/gR29UW290dmlOFqWHqx7SgKa2VtWVuPrjO8uplrt5a4sqdS9y4v4IvvexCkibFSq6UK5RLZdbL6zzdfEbpYYmN8gYqCP7tc/hTQSaOZ40dFcNyPZ/hqTdjEXv+zHZCMvKL8RO1AMFT3JQHzwAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Skytap",
          "title": "Skytap",
          "src": "/instana-humio-hybrid-systemZ/static/4fd6f1981ef884c1ef33edba5a571f3e/3cbba/Skytap.png",
          "srcSet": ["/instana-humio-hybrid-systemZ/static/4fd6f1981ef884c1ef33edba5a571f3e/7fc1e/Skytap.png 288w", "/instana-humio-hybrid-systemZ/static/4fd6f1981ef884c1ef33edba5a571f3e/a5df1/Skytap.png 576w", "/instana-humio-hybrid-systemZ/static/4fd6f1981ef884c1ef33edba5a571f3e/3cbba/Skytap.png 1152w", "/instana-humio-hybrid-systemZ/static/4fd6f1981ef884c1ef33edba5a571f3e/4fee2/Skytap.png 1542w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy",
          "decoding": "async"
        }}></img>{`
    `}</span></p>
    <p>{`  If the background is green, it means the virtual machine is running.  If it is not running, click the start arrow to start the VM
`}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "41px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "97.56097560975611%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAABW0lEQVQ4y62UvUrEQBSFg73gC1hoZ6OV6Ev4GL6EndVaiYKwoHaCnY213RbCEheTBbGxWCK6+SfJ7kImP0duYGZDEtckZuBMLgPzzblzb0YCgDRNO5NEU5dD4g5934fjOHBdN/s2kW3bIs6ABPE8D1EUIQxDMMYaSdd1EWdAy7L+lSY5FClTurRQdcFxUq8QZEgUhTvMFycfJ2maKd8NxZHPsJQy3+AsIgwmvliPkiWsCF4J5G6+gxB7fQXHjx/48sPSgY2Bxozh4GaM9d4Qu30Fd4qBME5KsNpAfcawf61i62KEzfMXrJ0+4+Rp0j5lAh7ejrFxNsT25Qi9wSfMOWsPnAYMO1evOLp/hzKdV3bASmDxssnNw5stDqAqJ3Wq/FtjA8sNfzV4ZWNXjSRt8evRpGmacBnHcWORIR5nQHp2VFWFLMutlN8rcatBEMAwDJim2VjkkMedv9g/dSMFe3jbpyAAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "2021 04 27 20 00 11",
          "title": "2021 04 27 20 00 11",
          "src": "/instana-humio-hybrid-systemZ/static/37244716675d44157bc09fe79b5f6125/11028/2021-04-27-20-00-11.png",
          "srcSet": ["/instana-humio-hybrid-systemZ/static/37244716675d44157bc09fe79b5f6125/11028/2021-04-27-20-00-11.png 41w"],
          "sizes": "(max-width: 41px) 100vw, 41px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy",
          "decoding": "async"
        }}></img>{`
    `}</span></p>
    <p>{`  For more information on using the soleil environment, scroll towards the bottom of the page.`}</p>
    <h2>{`Begin the Exercises`}</h2>
    <p>{`You are now ready to start performing the lab exercises.  After that, the sections can be done in any order.  For a new user of Instana, we recommend
performing the `}<strong parentName="p">{`Explore Instana`}</strong>{` section of the lab next.  If you are already familiar with Instana, you can select immediately the systemZ lab.`}</p>
    <p>{`Select one of the lab exercises in the upper left corner or select one of the images below.`}</p>
    <Row mdxType="Row">
      <Column colLg={2} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" subTitle="Explore Instana" title="Explore the Instana UI and Capabilities" href="/tutorials/Explore" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "51.388888888888886%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABt0lEQVQoz21SwW7UMBDNb0FVISEER4RKBYKWG/wKv4M48AccOHBqixZos9vQZLPZzSabxI7tsf2q8Waj3YonjTQaj5/fvHH05PQMSb3AVTLFn/gfrm9TxMkc09sMl/kS38sSuZCwZKGJtmG2obRB03aoNw2U1pC9QvTiwyfkusLNMsPlJMbFJMbV3xl+/Z7iR5LiW54jaVs4a6GMBZGFtS4EcZAF2aHmHKLn5x9htUWvCeQdDkAEWAdPBGMIUjQwRgMe8I7gvYP3HsSqtQk90fHrM0ht4LwPHJ0QQTojSeeommbkXxUzaC0hlUGxuEEnGjgm96zYwrHCZ6fnodkPhKt1FXzZCrQsBpumhez7kVgbg15pKKUDyT6ipyfvxuJOJaPtOqTzRcizvMCm6WCMwjydhFqvFPJiOd7zQ0THJ+/HQlBYrrGuNyHnzTGKZYmGF+MchOzDeNy/rmr0gz0j4dGrtwcjt52AkDLkd1mOTshwxl5VqxnIyHGKYlWiHjzeiYoevXxz8MI+yqqGIQp1VsXe7RbHD/8P0eMHhPvE7B1/ibDxu2xUzpbwuFt4fIkFPv+s8XUqcA/2ofXRngDf/wAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "InstanaTopology",
              "title": "InstanaTopology",
              "src": "/instana-humio-hybrid-systemZ/static/89b2ea37affa992b5541f69f4591372a/3cbba/InstanaTopology.png",
              "srcSet": ["/instana-humio-hybrid-systemZ/static/89b2ea37affa992b5541f69f4591372a/7fc1e/InstanaTopology.png 288w", "/instana-humio-hybrid-systemZ/static/89b2ea37affa992b5541f69f4591372a/a5df1/InstanaTopology.png 576w", "/instana-humio-hybrid-systemZ/static/89b2ea37affa992b5541f69f4591372a/3cbba/InstanaTopology.png 1152w", "/instana-humio-hybrid-systemZ/static/89b2ea37affa992b5541f69f4591372a/0b124/InstanaTopology.png 1728w", "/instana-humio-hybrid-systemZ/static/89b2ea37affa992b5541f69f4591372a/fa64a/InstanaTopology.png 1907w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
      <Column colLg={4} colMd={4} noGutterMdLeft mdxType="Column">
        <ArticleCard color="dark" subTitle="Instana and the mainframe" title="Learn How Instana Can Help you with hybrid applications that include Mainframe components" href="/tutorials/Instana on Z" actionIcon="arrowRight" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "51.388888888888886%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABzUlEQVQoz2WS3W7TQBCF/VgI8RMk6CVcICpoqIAiriqQ4EV4FS4oD0AFqtIbVDVEKGmbXpWfJP6LveudXX9oJyZqhaXRnjk+O57xnKT3aJtyWVHVBu8DIn4V3uOc4MT/F6Kn0DhHlhfkRan6RZqSbGztEEKgMpaiNtSmxlhLWdWKnXN6sXFNd8oa6wddo83Eglmek9x98pwsrfh5cUHTNIQW7dSLdLhd5YpjSIfbK5g2kKYZSW/zBcGMcaEiALhvrB93BCsW7CASl7Bf45ZWYZwqudffhdF7ZL+PDN4he7eRg1fI4DXy6Q7yZRs52EH2biD7W8jgDfLhFvL5KXL4FvnYQ74+Qw53cfkpyUb/Jc2vOWY8pJl+x56cY89GmOkx9mSKOY14iJlMMZMf2OkQOznHjiM+Vt6ejqjPjjBlQXLzYV/bNS2YABaQbqA4YNsN3XZ5bkRPd+n9P63zgeT6g8d6pSxL/alZmmGMQUSUWy4rxDm897q0LMspi5LGNqrzaiPRJcatJ9fub2rB6Kffszl/Zou1J2Oe5SU+BA3bOGbzhWqNXdkl8tEyUX+lYFEumacZiyynNlZFaZYrr7YJQb236LhYPPp1VTCsC/4FNKvnmsY3w3oAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "instanaEvents",
              "title": "instanaEvents",
              "src": "/instana-humio-hybrid-systemZ/static/f38820630a63c518260986dd240e034a/3cbba/instanaEvents.png",
              "srcSet": ["/instana-humio-hybrid-systemZ/static/f38820630a63c518260986dd240e034a/7fc1e/instanaEvents.png 288w", "/instana-humio-hybrid-systemZ/static/f38820630a63c518260986dd240e034a/a5df1/instanaEvents.png 576w", "/instana-humio-hybrid-systemZ/static/f38820630a63c518260986dd240e034a/3cbba/instanaEvents.png 1152w", "/instana-humio-hybrid-systemZ/static/f38820630a63c518260986dd240e034a/0b124/instanaEvents.png 1728w", "/instana-humio-hybrid-systemZ/static/f38820630a63c518260986dd240e034a/fa64a/instanaEvents.png 1907w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
      </Column>
    </Row>
    <hr></hr>
    <h2>{`Using the soleil environment`}</h2>
    <p>{`  There are a couple of things that are important to know when using the soleil environment.  At the top of the screen you will see a menu bar.  You’ll notice a full screen icon as shown below. You’ll have a much better experience with the lab if you use full screen.`}</p>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "450px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "7.638888888888888%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAACCAYAAABYBvyLAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAiUlEQVQI1x3KORKCMABAUe4i15CRjqEgjaRgC4hAFiLLBaSQc39nKF73gtk5pJTs+840jbStwjlLXVcYY9Bao/VE3784z9/1iqLAe4+1FqUUSZIghGBdVwKtDVkm+CwLbddRlhXGWp55zjCMl/cwUDcN3+Ng9p48lyjVkqYpjzjmFobco4ht2/kDWtdVGNPfDrUAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "2021 04 27 20 24 32",
          "title": "2021 04 27 20 24 32",
          "src": "/instana-humio-hybrid-systemZ/static/ab067aa7ba078c01ca30e4cabb5d3a61/532bf/2021-04-27-20-24-32.png",
          "srcSet": ["/instana-humio-hybrid-systemZ/static/ab067aa7ba078c01ca30e4cabb5d3a61/7fc1e/2021-04-27-20-24-32.png 288w", "/instana-humio-hybrid-systemZ/static/ab067aa7ba078c01ca30e4cabb5d3a61/532bf/2021-04-27-20-24-32.png 450w"],
          "sizes": "(max-width: 450px) 100vw, 450px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy",
          "decoding": "async"
        }}></img>{`
    `}</span></p>
    <p>{`  Another icon on the taskbar that is important is the clipboard icon`}</p>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "450px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "7.638888888888888%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAACCAYAAABYBvyLAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAh0lEQVQI1x3DSQqDMABAUe9U93Xdgi7qGDWaOmUoCQju7NJz/0IfvOjjHGVZsu8727YyjgPOWfq+wxiD1hqtN6bpzXVdHMeBEAKlFM/ng0FKrLW0QhCCJ9LakKYZPgRGpWjbDmMteVGwLOv/PC9IOXCeX6qq5p4kpFnGLY6pmwZrHa+8wPvAD0/tVXn++i9oAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "2021 04 28 10 47 13",
          "title": "2021 04 28 10 47 13",
          "src": "/instana-humio-hybrid-systemZ/static/4de010df1906b878e7d722ada9996b78/532bf/2021-04-28-10-47-13.png",
          "srcSet": ["/instana-humio-hybrid-systemZ/static/4de010df1906b878e7d722ada9996b78/7fc1e/2021-04-28-10-47-13.png 288w", "/instana-humio-hybrid-systemZ/static/4de010df1906b878e7d722ada9996b78/532bf/2021-04-28-10-47-13.png 450w"],
          "sizes": "(max-width: 450px) 100vw, 450px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy",
          "decoding": "async"
        }}></img>{`
    `}</span></p>
    <p>{`  The only way to paste content into the virtual machine is by using this icon.`}</p>
    <p>{`  To copy text into the virtual machine, perform a copy as you normally would do on your laptop/desktop.  Then, click the clipboard icon. You will notice that there is text within the clipboard user interface`}</p>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "599px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "47.91666666666667%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABp0lEQVQoz62SvW7bMBRG9aSdMnXs1Mfp2tcoOhRIByOwJSvWDyUrri2J+hdJy45PITqx070EDojv3nO3z/F9n00QIKWkaRrq+p2apmlRrbrRN72d350r811ZSqIowsn3O6oy53TUHM0VYxST0Yy657n1LV7jchj2nMzR7t/d241W9F2L89uN8cSBJO841KNlXw9UzcSyiHlYfubL+iuflg98E9/p2gt/qv7mfkS2GufnY8CPx5Bfi5jj6YKZXm/o6cwwafpJWdQ0/bO/e6+czhf2tcHhPz7ZTzi1OlP2E7I/UQ135uX8F62h6AxymK68zed/zh/9nVQ4kUhJty+INLPEyZZ5ts12xElKPyjabiDZZohka90gEqTZjuTtbs6HXKK0wQnDgCgKLULEJHFEGGxsDoKNrYQx2lZiziKOCYPrjYgjojBg7Xlk2RalRpynpydWq5Vl7T+zFhluEJMkKUIIiqJAKcXc18Vigeu6Fm/t40Upy01ELARpmtqOOmVZIqvKFruqG/J2pOwUSs99NGitGceRqqqwrpSURUEpK/Judke0Njf3LwZx70+75ukLAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "2021 04 27 20 40 37",
          "title": "2021 04 27 20 40 37",
          "src": "/instana-humio-hybrid-systemZ/static/b2a975d864e14ad6e15e01e3f3b0afc2/747eb/2021-04-27-20-40-37.png",
          "srcSet": ["/instana-humio-hybrid-systemZ/static/b2a975d864e14ad6e15e01e3f3b0afc2/7fc1e/2021-04-27-20-40-37.png 288w", "/instana-humio-hybrid-systemZ/static/b2a975d864e14ad6e15e01e3f3b0afc2/a5df1/2021-04-27-20-40-37.png 576w", "/instana-humio-hybrid-systemZ/static/b2a975d864e14ad6e15e01e3f3b0afc2/747eb/2021-04-27-20-40-37.png 599w"],
          "sizes": "(max-width: 599px) 100vw, 599px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy",
          "decoding": "async"
        }}></img>{`
    `}</span></p>
    <p>{`  This will make the text available within the virtual machine. Then, within the virtual machine, either type “Ctrl-V” or right-click and use your browser to paste the text into the virtual machine.`}</p>
    <p>{`  To copy text from the virtual machine, do the process in reverse.  Copy the text inside the virtual machine.  Then, click the clipboard icon and you will notice that the text is visible on the screen.`}</p>
    <p>{`  `}<span parentName="p" {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "599px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "47.91666666666667%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsTAAALEwEAmpwYAAABp0lEQVQoz62SvW7bMBRG9aSdMnXs1Mfp2tcoOhRIByOwJSvWDyUrri2J+hdJy45PITqx070EDojv3nO3z/F9n00QIKWkaRrq+p2apmlRrbrRN72d350r811ZSqIowsn3O6oy53TUHM0VYxST0Yy657n1LV7jchj2nMzR7t/d241W9F2L89uN8cSBJO841KNlXw9UzcSyiHlYfubL+iuflg98E9/p2gt/qv7mfkS2GufnY8CPx5Bfi5jj6YKZXm/o6cwwafpJWdQ0/bO/e6+czhf2tcHhPz7ZTzi1OlP2E7I/UQ135uX8F62h6AxymK68zed/zh/9nVQ4kUhJty+INLPEyZZ5ts12xElKPyjabiDZZohka90gEqTZjuTtbs6HXKK0wQnDgCgKLULEJHFEGGxsDoKNrYQx2lZiziKOCYPrjYgjojBg7Xlk2RalRpynpydWq5Vl7T+zFhluEJMkKUIIiqJAKcXc18Vigeu6Fm/t40Upy01ELARpmtqOOmVZIqvKFruqG/J2pOwUSs99NGitGceRqqqwrpSURUEpK/Judke0Njf3LwZx70+75ukLAAAAAElFTkSuQmCC')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "2021 04 27 20 40 37",
          "title": "2021 04 27 20 40 37",
          "src": "/instana-humio-hybrid-systemZ/static/b2a975d864e14ad6e15e01e3f3b0afc2/747eb/2021-04-27-20-40-37.png",
          "srcSet": ["/instana-humio-hybrid-systemZ/static/b2a975d864e14ad6e15e01e3f3b0afc2/7fc1e/2021-04-27-20-40-37.png 288w", "/instana-humio-hybrid-systemZ/static/b2a975d864e14ad6e15e01e3f3b0afc2/a5df1/2021-04-27-20-40-37.png 576w", "/instana-humio-hybrid-systemZ/static/b2a975d864e14ad6e15e01e3f3b0afc2/747eb/2021-04-27-20-40-37.png 599w"],
          "sizes": "(max-width: 599px) 100vw, 599px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy",
          "decoding": "async"
        }}></img>{`
    `}</span></p>
    <p>{`  Whatever text you see on the VM clipboard, you’ll be able to past within your laptop/desktop.`}</p>
    <p>{`  Note:  The clipboard is a little bit unreliable.  You may need to attempt to copy/paste a couple of timess.  Also, try to avoid clicking in multiple places on the screen. Copy the content (Ctrl-C), click on the clipboard, then immediately paste to either your laptop or into the virtual machine.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      